import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { AppContextProvider } from "@/context/AppContext";
import { AppLayout } from "@/layouts/AppLayout";

import { AccessPage } from "./AccessPage";
import { DebugBlockRoute } from "./DebugBlockRoute";
import { EditBlockRoute } from "./EditBlockRoute";
import { SettingsRoute } from "./SettingsRoute";
import { TableEditRoute } from "./TableEditRoute";
import { TableListRoute } from "./TableListRoute";
import { TableImportRoute } from "./TableImportRoute";
import { TableQuickAddRoute } from "./TableQuickAddRoute";
import { TableViewRoute } from "./TableViewRoute";

function RootRedirect() {
  return <Navigate replace to={hasAccessKey() ? "/tables" : "/access"} />;
}

function hasAccessKey() {
  const raw =
    typeof window !== "undefined" ? String(window.localStorage.accessKey ?? "") : "";
  return raw.trim().length > 0;
}

function RequireAccess() {
  if (!hasAccessKey()) {
    return <Navigate replace to="/access" />;
  }
  return <Outlet />;
}

function AppShell() {
  return (
    <AppContextProvider>
      <Outlet />
    </AppContextProvider>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/access" element={<AccessPage />} />
      <Route element={<RequireAccess />}>
        <Route element={<AppShell />}>
          <Route element={<AppLayout />}>
            <Route path="/tables" element={<TableListRoute />} />
            <Route path="/settings" element={<SettingsRoute />} />
            <Route path="/blocks/:blockId" element={<DebugBlockRoute />} />
            <Route path="/tables/:tableId/blocks/:blockId" element={<EditBlockRoute />} />
            <Route path="/tables/:id/quick-add" element={<TableQuickAddRoute />} />
            <Route path="/tables/:id/import" element={<TableImportRoute />} />
            <Route path="/tables/:id" element={<TableViewRoute />} />
            <Route path="/tables/:id/edit" element={<TableEditRoute />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<RootRedirect />} />
    </Routes>
  );
}
